import { createFileRoute } from "@tanstack/react-router";

import { CallsPage } from "../../../features/orders/calls-page";

export const Route = createFileRoute("/_app/orders/calls")({ component: CallsPage });
